import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, UrlTree } from '@angular/router';
import { map, Observable } from 'rxjs';
import { Permission } from '@shared/enums/permission';
import { AlertType } from '@shared/enums/notifications/notifications.enum';
import { PermissionService } from '@services/utils/permission.service';
import { AlertService } from '@services/utils/alert.service';

export const PermissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
  {
    const { permissions, routerLink }: { permissions?: Permission[]; routerLink?: string } = route.data;

    if (!permissions) {
      return true;
    }

    const permissionsService = inject(PermissionService);
    const alertService = inject(AlertService);
    const router = inject(Router);

    return permissionsService.hasUserPermissions(permissions).pipe(
      map(hasUserPermissions => {
        if (!hasUserPermissions) {
          alertService.show({
            severity: AlertType.Error,
            detail: 'PERMISSION_GUARD.NO_ACCESS',
          });

          return router.createUrlTree([routerLink ? routerLink : '/']);
        }
        return hasUserPermissions;
      }),
    );
  }
};
